import { takeLatest } from "redux-saga/effects";
import {
  Action,
  fetchInitialDataFailure,
  fetchInitialDataSuccess,
  handleCreateNewOrganizationFailure,
  handleCreateNewOrganizationSuccess,
  handleDeleteOrganizationFromPreviewFailure,
  handleDeleteOrganizationFromPreviewSuccess,
  handleGetOrgInfoFailure,
  handleGetOrgInfoSuccess,
  handleOrganizationPreviewFailure,
  handleOrganizationPreviewSuccess,
  middleErrorReport,
  patchRequestFailure,
  patchRequestImportFailure,
  patchRequestImportSuccess,
  patchRequestSuccess,
  refreshSettingsFailure,
  refreshSettingsSuccess,
  requestAllTableDataFatalError,
  requestAllTableDataFinished,
  stepOnAllTableDataRequest,
} from "../../App/Organization/OrganizationSettings/actions";
import {
  createNewOrganization,
  deleteOrganization,
  deleteOrganizationFromPreview,
  fetchOrganizationPreview,
  fetchSettings,
  getOrgInfo,
  patchImports,
  patchSettings,
  requestAllAssessmentData,
  requestAllUserData,
} from "../../App/Organization/OrganizationSettings/actions/sagas";

export function* watchFetchInitialData() {
  yield takeLatest(
    Action.FETCH_INITIAL_DATA,
    fetchSettings({
      onFailure: fetchInitialDataFailure,
      onSuccess: fetchInitialDataSuccess,
    })
  );
}

export function* watchDeleteOrganization() {
  yield takeLatest(
    Action.DELETE_ORGANIZATION,
    deleteOrganization({
      onFailure: patchRequestFailure,
      onSuccess: patchRequestSuccess,
    })
  );
}

export function* watchPatchSettings() {
  yield takeLatest(
    Action.PATCH_REQUEST,
    patchSettings({
      onFailure: patchRequestFailure,
      onSuccess: patchRequestSuccess,
    })
  );
}

export function* watchPatchImportsSettings() {
  yield takeLatest(
    Action.PATCH_REQUEST_IMPORT,
    patchImports({
      onFailure: patchRequestImportFailure,
      onSuccess: patchRequestImportSuccess,
    })
  );
}

export function* watchRefreshSettings() {
  yield takeLatest(
    Action.REFRESH_SETTINGS,
    fetchSettings({
      onFailure: refreshSettingsFailure,
      onSuccess: refreshSettingsSuccess,
    })
  );
}

const requestAllTableDataFA = {
  onFatalError: requestAllTableDataFatalError,
  onFinish: requestAllTableDataFinished,
  onMiddleError: middleErrorReport,
  onStep: stepOnAllTableDataRequest,
};

export function* watchRequestAllUserData() {
  yield takeLatest(Action.REQUEST_ALL_USER_DATA, requestAllUserData(requestAllTableDataFA));
}

export function* watchRequestAllAssessmentData() {
  yield takeLatest(Action.REQUEST_ALL_ASSESSMENT_DATA, requestAllAssessmentData(requestAllTableDataFA));
}

export function* watchFetchOrganizationPreview() {
  yield takeLatest(
    Action.FETCH_ORG_PREVIEW,
    fetchOrganizationPreview({
      onFailure: handleOrganizationPreviewFailure,
      onSuccess: handleOrganizationPreviewSuccess,
    })
  );
}

export function* watchCreateNewOrganization() {
  yield takeLatest(
    Action.CREATE_NEW_ORGANIZATION,
    createNewOrganization({
      onFailure: handleCreateNewOrganizationFailure,
      onSuccess: handleCreateNewOrganizationSuccess,
    })
  );
}

export function* watchGetOrgInfo() {
  yield takeLatest(
    Action.GET_ORG_INFO,
    getOrgInfo({
      onFailure: handleGetOrgInfoFailure,
      onSuccess: handleGetOrgInfoSuccess,
    })
  );
}

export function* watchDeleteOrganizationFromPreview() {
  yield takeLatest(
    Action.DELETE_ORGANIZATION_FROM_PREVIEW,
    deleteOrganizationFromPreview({
      onFailure: handleDeleteOrganizationFromPreviewFailure,
      onSuccess: handleDeleteOrganizationFromPreviewSuccess,
    })
  );
}
